import React, { memo } from "react";
import PropTypes from "prop-types";

import styles from "./style.css";

function isEmpty(obj) {
  return !obj || Object.keys(obj).length === 0;
}

function LookupComponent({ value, column }) {
  const { fields = [], hiddenFields = [] } = column;
  const visibleTextFields = fields.filter(
    ({ Id, Type }) => hiddenFields.indexOf(Id) === -1 && Type === "Text"
  );
  let label = "";
  if (
    value &&
    visibleTextFields[0] &&
    visibleTextFields[0].Id &&
    value[visibleTextFields[0].Id]
  ) {
    label = value[visibleTextFields[0].Id];
  } else if (value && hiddenFields.indexOf("Name") === -1 && value.Name) {
    label = value.Name;
  }

  return (
    <div
      className={`${!isEmpty(value) ? styles.lookup : ""} ellipsis ${
        !label ? styles.emptyvalue : ""
      }`}
    >
      {value && label && label}
      {!isEmpty(value) && !label && visibleTextFields?.[0]?.Name
        ? `${visibleTextFields[0].Name}: undefined`
        : ""}
    </div>
  );
}

LookupComponent.propTypes = {
  value: PropTypes.string,
  column: PropTypes.any
};

export const Lookup = memo(LookupComponent);
